/**
* 订单管理 交易订单
*/
<template>
  <div class="wrapper">

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item>
        <el-select size="small" v-model="formInline.payTimeType" @change="search">
          <el-option v-for="type in payTimeType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column sortable prop="orderNo" label="订单号" width="120" show-overflow-tooltip>
      </el-table-column>


      <el-table-column sortable prop="orderInfo" label="订单信息" width="140" show-overflow-tooltip>
      </el-table-column>


      <el-table-column sortable prop="realTotalMoney" label="订单金额(元)" width="120" show-overflow-tooltip>
      </el-table-column>
      <!--      <el-table-column sortable prop="realTotalMoney" label="实付金额(元)" width="180" show-overflow-tooltip>-->
      <!--      </el-table-column>-->

      <el-table-column sortable prop="payType" label="支付方式" width="140" :formatter="formatPayType"
                       show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="payStatus" :formatter="formatPayStatus" label="订单状态" width="120"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="invoiceStatus" :formatter="formatInvoiceStatus" label="发票状态" width="120"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="creatTime" label="下单时间" width="180" show-overflow-tooltip>

      </el-table-column>

      <el-table-column sortable prop="payTime" label="支付时间" width="180" show-overflow-tooltip>

      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button v-if="scope.row.payStatus==0" size="mini" @click="handlePay(scope.$index, scope.row)">去支付
          </el-button>
          <el-button v-if="scope.row.payStatus==1 " size="mini" @click="handleInvoice(scope.$index, scope.row)"
                     :disabled="scope.row.invoiceStatus!=0">去开票
          </el-button>

          <el-button size="mini" type="danger" @click="deleteOrder(scope.$index, scope.row)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票抬头">
              <el-input size="small" v-model="editForm.invoiceHead" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="开具类型">
              <el-input size="small" v-model="editForm.type" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="发票类型">
              <el-input size="small" v-model="editForm.invoiceType" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号">
              <el-input size="small" v-model="editForm.invoiceCode" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="开户银行名称">
              <el-input size="small" v-model="editForm.invoiceBankName" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="开户账号">
              <el-input size="small" v-model="editForm.invoiceBankNo" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="注册场所地址">
              <el-input size="small" v-model="editForm.invoiceAddr" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="注册固定电话">
              <el-input size="small" v-model="editForm.invoicePhone" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票金额(元)">
              <el-input size="small" v-model="this.row.realTotalMoney" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="收件人">
              <el-input size="small" v-model="editForm.userName" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="收件人号码">
              <el-input size="small" v-model="editForm.userPhone" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="收件人地址">
              <el-input size="small" v-model="editForm.userAddress" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-button style="margin-left: 10vw ;margin-top:3vw" type="primary" :disabled="this.submitButton"
                       @click="submitInvoice">提交开票信息
            </el-button>

          </el-col>


        </el-row>


      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import {getInvoice, getOrderList, getAddress, submitInvoiceApi, deleteOrderApi} from '../../api/payMG'

export default {
  data() {
    return {
      row: {},
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      userId: "",
      submitButton: true,
      payTimeType: [
        {key: '全部', value: 0},
        {key: '近三个月订单', value: 3},
        {key: '近六个月订单', value: 6},
        {key: '近一年订单', value: 12}
      ],

      editForm: {},

      formInline: {},

      listData: [], //用户数据
      month: 0

    }
  },

  /**
   * 创建完毕
   */
  created() {
    this.userId = this.$store.getters.getUserInfo.userId;
    this.getdata({
      "userId": this.userId,

    })

  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    deleteOrder: function (index, row) {

      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let that = this;
        deleteOrderApi(row).then(response => {
          if (response.status == 200) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            });

            that.getdata(
              {
                "userId": this.userId,
                "month": this.month
              }
            )

          } else {
            that.$message({
              type: 'warning',
              message: response.message
            });
          }
        }).catch(e => {
          this.$message.warning("网络异常,请稍后重试");
          console.log(e)
        })


      }).catch(() => {

      })
    },

    submitInvoice() {
      this.editForm.userId = this.userId;

      this.editForm.orderId = this.row.orderId;
      this.editForm.orderNo = this.row.orderNo;
      this.editForm.orderInfo = this.row.orderInfo;
      this.editForm.totalMoney = this.row.realTotalMoney;
      this.editForm.address = this.editForm.userAddress;

      let params = this.editForm;


      let that = this;

      submitInvoiceApi(
        params
      ).then(response => {
        if (response.status == 200) {
          that.$message.success("提交开票信息成功");
          that.getdata(
            {
              "userId": this.userId,
              "month": this.month
            }
          )
        } else {
          that.$message.success(response.message);
        }
        this.editFormVisible = false
      }).catch(e => {
        console.log(e)
        this.$message.error("网络异常,请稍后重试！")
      })
    },

    formatInvoiceStatus(row, column) {
      if (row.invoiceStatus == 0) {
        return "未开票"
      }
      if (row.payStatus == 1) {
        return "已申请"
      }
      if (row.payStatus == 1) {
        return "已开票"
      }


    },
    formatPayStatus(row, column) {

      if (row.payStatus == 0) {
        return "未支付"
      }
      if (row.payStatus == 1) {
        return "已支付"
      }
      return "未知"

    },
    formatPayType(row, column) {

      if (row.payType == 0) {
        return "免费"
      }
      if (row.payType == 1) {
        return "微信支付"
      }
      if (row.payType == 2) {
        return "支付宝支付"
      }
      return "未知"

    },

    getdata(parameter) {
      this.loading = true
      getOrderList(parameter).then(response => {
        if (response.status != 200) {
          this.$message.warning(response.message);
          return;
        } else {

          this.listData = response.data;
        }
      }).catch(e => {
        console.log(e)
      })
      this.loading = false

      // 模拟数据结束
    },

    // 搜索事件
    search(value) {
      this.month = value;
      this.getdata(
        {
          "userId": this.userId,
          "month": this.month
        }
      )


    },

    //显示开票界面
    handleInvoice: function (index, row) {
      this.editFormVisible = true
      this.row = row;
      let that = this;
      getInvoice(this.userId).then(response => {

        if (response.status == 200) {
          this.editForm = response.data
          this.editForm.type == 0 ? this.editForm.type = "个人" : this.editForm.type = "企业"
          this.editForm.invoiceType == 0 ? this.editForm.invoiceType = "增值税普通发票" : this.editForm.invoiceType = "增值税专用发票"
          getAddress(that.userId).then(response => {
            if (response.status == 200) {
              console.log(response.data)
              if (response.data != null && response.data.length > 0) {

                that.$set(this.editForm, 'userName', response.data[0].userName);
                that.$set(this.editForm, 'userPhone', response.data[0].userPhone);
                that.$set(this.editForm, 'userAddress', response.data[0].areaPath + response.data[0].address);
                that.submitButton = false;
              } else {

                this.$confirm('您尚未录入收件人信息, 请先录入收件人信息!', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.$router.push("/pay/Invoice")
                }).catch(() => {
                  this.editFormVisible = false
                });


              }

            } else {
              this.$confirm('您尚未录入收件人信息, 请先录入收件人信息!', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.push("/pay/Invoice")
              }).catch(() => {
                this.editFormVisible = false
              });

            }
          }).catch(e => {
            console.log(e)
            that.$message.warning("获取收件人信息异常")
          })


        } else {

          this.$confirm('您尚未录入开票信息, 请先录入开票信息!', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push("/pay/Invoice")
          }).catch(() => {
            this.editFormVisible = false
          });


        }
      }).catch(e => {
        console.log(e)
        that.$message.warning("网络异常，请稍后重试")
      })

      this.editForm = row
    },
    handlePay: function (index, row) {

      this.$router.push({
        path: '/pay/payOrder', query: {
          goodsId: row.goodsId,
          applicationId: row.applicationId,
          orderNo: row.orderNo,
          payIndex: row.payType
        }
      })

    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.wrapper{
  padding: 5vw 4vw;
}

</style>







// WEBPACK FOOTER //
// src/views/pay/SysInvoice.vue